import React, { useMemo } from 'react';
import useCopyToClipboard from 'react-use/esm/useCopyToClipboard';
import { useApi } from '@backstage/core-plugin-api';
import {
  DefaultTechDocsHome,
  EntityListDocsTable,
  TechDocsPageWrapper,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';
import {
  Content,
  ContentHeader,
  Progress,
  SupportButton,
} from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityListProvider,
  entityPresentationApiRef,
} from '@backstage/plugin-catalog-react';
import { useGuestState } from '../guest';
import { FacetedEntityTagPicker } from '../catalog/filters';

const GuestDocsTable = () => {
  const entityPresentationApi = useApi(entityPresentationApiRef);
  const [, copyToClipboard] = useCopyToClipboard();

  const columns = useMemo(
    () => [
      EntityListDocsTable.columns.createTitleColumn({
        hidden: true,
        entityPresentationApi,
      }),
      EntityListDocsTable.columns.createNameColumn({ entityPresentationApi }),
      EntityListDocsTable.columns.createKindColumn(),
      EntityListDocsTable.columns.createTypeColumn(),
    ],
    [entityPresentationApi],
  );

  const actions = useMemo(
    () => [
      EntityListDocsTable.actions.createCopyDocsUrlAction(copyToClipboard),
    ],
    [copyToClipboard],
  );

  return <EntityListDocsTable columns={columns} actions={actions} />;
};

const GuestTechDocsHome = () => (
  <TechDocsPageWrapper>
    <Content>
      <ContentHeader title="">
        <SupportButton>
          Discover documentation in your organization.
        </SupportButton>
      </ContentHeader>
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <TechDocsPicker />
            <FacetedEntityTagPicker />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <GuestDocsTable />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </Content>
  </TechDocsPageWrapper>
);

export const GuestAwareTechDocsHome = () => {
  const { isGuest, loading } = useGuestState();

  if (loading) {
    return <Progress />;
  }

  return isGuest ? <GuestTechDocsHome /> : <DefaultTechDocsHome />;
};
